export const SET_CUSTOM_LIST_OPTIONS = 'SET_CUSTOM_LIST_OPTIONS';
export function setCustomListOptions(customList) {
    return {
        type: SET_CUSTOM_LIST_OPTIONS,
        customList,
    };
}
